import React from "react";
import _ from 'lodash';
import PageHead from "components/page-head";
import styled from "styled-components";
import { Formik } from "formik";
import BusinessOverviewForm from "./form";
import { maxQuery } from "utils/responsivenessHelper";
import api from "api";
import user from "containers/user";
import * as yup from "yup";
import { successfulSaveNotification } from "utils/notifications";
import actionContext from "../shared/forms/action-context";
import { navigate } from "@reach/router";
import routes from "utils/absoluteRoutes";

const Container = styled.div`
  width: 100%;
`;

const ActionContextContainer = styled.div`
  display: none;
  ${maxQuery.both({ display: "flex" }, "850px")}

  button {
    width: 17em;
    margin: 0 auto;
  }
`;

const BusinessOverview = ({ location }) => {
  const { state: { data } } = location;
  const { my_uuid_id, partner_id, parent_partner_id } = user.state?.profile;

  // const [initialValues, setInitialValues] = useState({ summary: "" });

  // useEffect(() => {
  //   getSummary();
  // }, []);

  // async function getSummary() {
  //   const response = await api.users.getById(user.state.id);
  //   const summary = response.data.biography || "";
  //   setInitialValues({ summary });
  // }

  let initialValues = {
    business_description: '',
    team_members: []
  };
  
   if(data !== undefined){
    if (!_.isNil(data.business_description)) initialValues.business_description = data.business_description;
    if (!_.isNil(data.team_members)) initialValues.team_members = data.team_members;
  }
  async function onSubmit(values) {
    await api.business.setRequirement(parent_partner_id, partner_id, my_uuid_id, 'business_overview', {
      business_description: values.business_description,
      team_members: values.team_members
    });
    successfulSaveNotification();
    navigate(routes.bizProfile);
  }

  return (
    <Container>
      <Formik
        initialValues={initialValues}
        validationSchema={yup.object().shape({
          business_description: yup
            .string()
            .required()
            .min(2)
            .max(1000)
            .label("Business Overview"),
        })}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ handleSubmit, ...rest }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <PageHead
              title="Business Overview"
              actionContext={actionContext(rest)}
            />
            <BusinessOverviewForm />
            <ActionContextContainer>
              {actionContext(rest)}
            </ActionContextContainer>
          </form>
        )}
      </Formik>
    </Container>
  );
};

export default BusinessOverview;
